import React from 'react'
import { BiExitFullscreen } from 'react-icons/bi'
import { FiShare2 } from 'react-icons/fi'

const BigImg = (props) => {
    function shareLink(){
        if (navigator.share) {
          navigator.share({
            url: props.bigImgUrl
          })
            .then(() => {
              console.log('Link shared successfully!');
            })
            .catch((error) => {
              console.error('Error sharing link:', error);
            });
        } else {
          console.error('Share API is not supported in this browser.');
        }
      }
  return (
    <div className={`big-img ${props.showbigImg && "show-me"}`}>
        <div className="content">
            <img src={props.bigImgUrl} alt="fullscreen" />
            <div className="controls">
                <div className="close" onClick={props.hideBigImg}>
                    <BiExitFullscreen />
                </div>
                <div onClick={shareLink} className='download' href={props.bigImgUrl} download rel='noreferrer'>
                    <FiShare2 />
                </div>
            </div>
        </div>
    </div>
  )
}

export default BigImg